import styled from 'styled-components';

import colors from 'styles/theme/colors';

export default styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  border-radius: 8px;
  border: 1px solid ${colors.aiPurple}1A;
  background: linear-gradient(
    270deg,
    rgba(107, 69, 184, 0.075) 0%,
    rgba(98, 65, 205, 0.0871438) 48.58%,
    rgba(89, 62, 228, 0.1) 100%
  );
`;
